import { TipoFirmante } from "../../envios/models/tipo-firmante";

export interface FirmanteNif{
  tipoFirmante: TipoFirmante;
  nifPage: number;
  nifOrden: number;
  nifFormulario:string;
  /** NIF resuelto por página/orden; solo UI, no se envía al backend. */
  nif?: string;
  posicionNif: string;
  firmas: ConfiguracionFirma;
  formularios: PosicionFormulario[];
  camposEditables: PosicionFirma[];
  tipoDestinatario?: TipoFirmante;
  tipoBusqueda?: TipoFirmante;
  orden?: number;
}

export interface ConfiguracionFirma{
  tipoFirma: TipoFirma;
  nombreCertificado: string;
  tieneTag: boolean;
  nombreTag: string;
  posicionFirmas: PosicionFirma[];
}

export interface PosicionFirma{
  id: number;
  pagina: number;
  posicionTop: number;
  posicionLeft: number;
  posicionRight: number;
  posicionWidth: number;
  posicionHeight: number;
  identificador?: string;
  nombreCampo?: string;
  valorPorDefecto?: string;
  obligatorio?: boolean;
}

export interface PosicionFirmaConFirmante extends PosicionFirma{
  firmante: TipoFirmante;
}

export interface PosicionFormulario extends PosicionFirma{
  nombre: string;
  orden: number;
  valorOpcionSeleccionada: string;
  obligatorio: boolean;
  idNombreFormulario?: number;
}

export interface PosicionFormularioConFirmante extends PosicionFormulario{
  firmante: TipoFirmante;
}

export interface PosicionCampoConFirmante extends PosicionFirma{
  firmante: TipoFirmante;
}

export enum TipoFirma{
  Dibujada = "DIBUJADA",
  Certificado = "CERTIFICADO",
  Validador = "VALIDADOR",
  SinFirma = "SIN FIRMA"
}

export interface FirmaDibujo{
  id: number;
  pagina: number;
  x: number;
  y: number;
  width: number;
  height: number;
  firmante: TipoFirmante;
  identificador?: string;
  nombreCampo?: string;
  valorPorDefecto?: string;
  obligatorio?: boolean;
}

export interface CasillaDibujo{
  id: number;
  pagina: number;
  x: number;
  y: number;
  width: number;
  height: number;
  firmante: TipoFirmante;
  orden: number;
  nombre: string;
  valorOpcionSeleccionada?: string;
  obligatorio?: boolean;
  identificador?: string;
  nombreCampo?: string;
  valorPorDefecto?: string;
  idNombreFormulario?: number;
}

export interface ErroresForm{
  firmante: TipoFirmante;
  error: string;
}

export interface CoordenadasObjeto{
  left: number,
  top: number,
  height: number,
  width: number
}
